import React from 'react'
import { match } from 'ts-pattern'

import { InfoCard } from '@frame/ui-primitives/info-card'

export enum PlatformInfoType {
  PLATFORM_SEARCH,
  PLATFORM_CHECK,
}

type Props = {
  type: PlatformInfoType
  className?: string
}

export function PayrollProviderInfo({ type, className }: Props) {
  // Subtle intentional differences between the two info cards, as conveyed in the designs
  return match(type)
    .with(PlatformInfoType.PLATFORM_CHECK, () => (
      <InfoCard className={className}>
        <p>
          The <span className="font-medium">payroll provider</span> can be found on:
        </p>
        <ul className="ml-2 mt-1 list-inside list-disc">
          <li>Paystub</li>
          <li>Direct deposit statement</li>
          <li>W2 and tax document center</li>
          <li>Timesheet</li>
        </ul>
      </InfoCard>
    ))
    .with(PlatformInfoType.PLATFORM_SEARCH, () => (
      <InfoCard className={className}>
        <p>
          The <span className="font-medium">payroll provider</span> is the company that handles paychecks for your
          employer. It will be listed on:
        </p>
        <ul className="ml-2 mt-1 list-inside list-disc">
          <li>Paystubs</li>
          <li>Direct deposit statements</li>
          <li>W2 and tax document center</li>
          <li>Timesheets</li>
        </ul>
      </InfoCard>
    ))
    .otherwise(() => null)
}
